<!--
 * @Author: Cathy
 * @Date: 2020-02-25 16:52:06
 * @LastEditors: yezi
 * @LastEditTime: 2020-03-16 17:04:48
 * @Description: 产品描述
 -->
<template>
  <div class="productDetail">
    <topMenu :isShowMenu="false"
             pageType="product" />
    <lianbaDownLoad :downloadLink="downloadLink" />
    <div class="describe"
         v-html="content"></div>
  </div>
</template>

<script>
import topMenu from '../components/topMenu'
import lianbaDownLoad from '../components/lianbaDownLoad'
export default {
  name: 'productDetail',
  components: {
    topMenu,
    lianbaDownLoad
  },
  data () {
    return {
      content: '',
      downloadLink: ''
    }
  },
  created () {
    this.content = this.$route.query.content.replace(/<h1/g, "<h1 style='font-size: .32rem'")
    this.downloadLink = this.$route.query.downloadLink
  },
  methods: {}
}
</script>

<style scoped>
.describe {
  /* margin-top: 0.54rem; */
  margin-left: 0.2rem;
  margin-right: 0.2rem;
  font-size: 0.28rem;
}
.describe >>> img {
  width: 100%;
}
</style>
